type EventValue = string | number | boolean | undefined

declare global {
  interface Window {
    dataLayer?: Array<Record<string, EventValue>>
  }
}

export const trackEvent = (event: string, details: Record<string, EventValue> = {}) => {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...details })
}
